module.exports = __webpack_public_path__ + "img/fazole-9.fb0c7fe2.png";